var map = {
	"./arpart.json": [
		"iQkj",
		7
	],
	"./enpart.json": [
		"k8yY",
		6
	],
	"./espart.json": [
		"/Vu4",
		5
	],
	"./idpart.json": [
		"cIRn",
		4
	],
	"./thpart.json": [
		"gK/5",
		3
	],
	"./twpart.json": [
		"I5cO",
		2
	],
	"./zhpart.json": [
		"c7Ac",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5VaQ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/common/lang lazy ^\.\/.*part\.json$
// module id = 5VaQ
// module chunks = 79